import React from 'react';

// Shared button styling to ensure consistent design system across the app.
// Requirements:
// - Default: transparent background, primary border, primary text/icon
// - Hover: primary background, white text/icon
// - Consistent padding, radius, and transitions
// - Accessibility: visible focus ring and safe disabled styles
const baseButtonClasses =
  'font-bold py-2 px-4 rounded-lg border transition-colors duration-200 ' +
  'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed';

const Button = ({
  children,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  width = 'w-32',
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${width} ${baseButtonClasses} bg-transparent border-primary text-primary hover:bg-primary hover:text-white hover:border-primary ${className}`}
    >
      {children}
    </button>
  );
};

const SecondaryButton = ({
  children,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  width = 'w-32',
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${width} ${baseButtonClasses} bg-transparent border-primary text-primary hover:bg-primary hover:text-white hover:border-primary ${className}`}
    >
      {children}
    </button>
  );
};

export { Button, SecondaryButton };
